module.exports = __webpack_public_path__ + "img/2013.a7412d5c.jpg";